import { useQuery } from "react-query";
import yearPlanAPI from "../../../api/yearPlanAPI";

export const useYearPlans = () =>
  useQuery("yearPlans", yearPlanAPI.fetchYearPlans);
